import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { PurchaseContractDetailProvider } from './context/purchase-contract-detail-context';
import { PurchaseContractDetailComponent } from './purchase-contract-detail-component';

export function PurchaseContractDetailFactory() {
  return (
    <BaseLayoutFactory>
      <PurchaseContractDetailProvider>
        <PurchaseContractDetailComponent />
      </PurchaseContractDetailProvider>
    </BaseLayoutFactory>
  );
}
